import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: "Index",
        component: () => import('../views/index/index.vue')
    },
    {
        path: '/login',
        name: "test",
        component: () => import('../views/login/login.vue')
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router